module.exports = __webpack_public_path__ + "static/media/twoThird.54a06093.png";